export default "__VITE_ASSET__CORs2pEz__"